import React from 'react';
import ScoreWithStarDisplay from "@Pages/reviews/components/ScoreWithStarDisplay";
import {useTranslation} from "@Translation/hooks/useTranslation";

const FilteredScore = ({score, numberOfReviews}) => {
    const labelText = useTranslation("global_review_page.score_for_filtered_reviews")

    return (
        <section className="gb--card-reviews gb--card">
            <ScoreWithStarDisplay score={score} numberOfRatings={numberOfReviews}/>
            <p>{labelText}</p>
        </section>
    )
}

export default FilteredScore;